import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constant } from '../shared/constants/constant.class';
import { GeneralService } from './general-service';

import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
  Messaging,
  isSupported
} from 'firebase/messaging';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  currentMessage = new BehaviorSubject<any>(null);
  private messaging: Messaging | null = null;
  // Kiểm tra trình duyệt/webview có hỗ trợ Firebase Messaging không (Push API, Notification API...).
  // Nhiều in-app browser (Zalo, Telegram, Messenger...) không hỗ trợ, gọi getMessaging() trực tiếp
  // sẽ throw lỗi ngay tại constructor và làm trắng màn hình toàn app.
  private readonly supportPromise: Promise<boolean>;

  constructor(
    private generalService: GeneralService,
    private ngZone: NgZone
  ) {
    this.supportPromise = this.initMessaging();
  }

  private async initMessaging(): Promise<boolean> {
    try {
      const supported = await isSupported();
      if (!supported) {
        console.warn('[FCM] Trình duyệt/app hiện tại không hỗ trợ Firebase Messaging, bỏ qua khởi tạo.');
        return false;
      }

      // Khởi tạo Firebase App
      const app = initializeApp(environment.firebase);

      // Khởi tạo Messaging
      this.messaging = getMessaging(app);

      // Lắng nghe message khi app đang mở
      this.listenForegroundMessage();
      return true;
    } catch (err) {
      console.error('[FCM] Không thể khởi tạo Firebase Messaging:', err);
      this.messaging = null;
      return false;
    }
  }

  // ===============================
  // 1️⃣ Xin quyền & lấy token
  // ===============================
  async requestPermission() {
    try {
      const supported = await this.supportPromise;
      if (!supported || !this.messaging) {
        return;
      }

      const curToken = localStorage.getItem(Constant.FIREBASE_TOKEN);

      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey   // BẮT BUỘC
      });

      if (!token) {
        console.warn('No registration token available.');
        return;
      }

      if (token !== curToken) {
        const payload = {
          token,
          deviceType: 'web'
        };

        this.generalService.saveToken(payload).subscribe(() => {
          localStorage.setItem(Constant.FIREBASE_TOKEN, token);
        });
      }

      console.log('FCM Token:', token);

    } catch (err) {
      console.error('Unable to get permission to notify.', err);
    }
  }

  // ===============================
  // 2️⃣ Nhận message khi đang mở app
  // ===============================
  private listenForegroundMessage() {
    /*onMessage(this.messaging, (payload) => {
      this.ngZone.run(() => {
        console.log('Message received: ', payload);
        this.currentMessage.next(payload);
      });
    });*/
  }

}
